import React, { useEffect, useState } from 'react'

import ReferralCard from './ReferralCard'
import { count } from 'services/referral'
import { legacyImageURL } from 'components/LegacyImage'

import './ReferralCardScreen.scss'

// voteType String - "NONE", "PER_ITEM", "ALL_ITEMS"

const ReferralCardScreen = ({
  referralLinks,
  referralId,
  onLinkClick,
  layout,
  voteType = 'NONE',
  // PUCK-BACKEND-GAP (BR-5452): no beaker referral entity — skip the counts
  // fetch and tally locally. Remove when the backend supports puck voting.
  mockVoting = false,
}) => {
  const [allCardVotes, setAllCardVotes] = useState([])

  // keep track of additional votes for each card.
  // (each card does this for itself - we need this to udpate the totals)
  // forces a re-render, which we want
  const [realTimeVotes, setRealTimeVotes] = useState(0)

  const getReferralLinkVotes = linkId => {
    let isLink = vote => {
      return vote.linkId === linkId
    }
    let link = allCardVotes.find(isLink)
    let count = link ? link.count : 0
    return count
  }

  // The total number of votes passed to each card differs depending on the voteType.
  const getReferralLinkTotalVotes = linkId => {
    let result = 0

    if (voteType === 'ALL_ITEMS') {
      result = allCardVotes.reduce((acc, link) => {
        return acc + link.count
      }, 0)
      result += realTimeVotes
    } else {
      let link = allCardVotes.find(vote => {
        return vote.linkId === linkId
      })
      result = link ? link.count : 0
    }

    return result
  }

  const handleLinkClick = link => {
    setRealTimeVotes(realTimeVotes + 1)
    onLinkClick(link)
  }

  useEffect(() => {
    if (voteType !== 'NONE' && !mockVoting) {
      count(referralId).then(res => {
        setAllCardVotes(res.detail)
      })
    }
  }, [referralId, setAllCardVotes, mockVoting])

  return (
    <div className="referral-cards">
      {referralLinks.map(link => (
        <ReferralCard
          imgUrl={legacyImageURL(link.headerImage)}
          media={link.puckMedia}
          linkUrl={link.url}
          linkId={link.id}
          title={link.topText}
          subtitle={link.bottomText}
          ctaText={link.buttonText}
          key={link.id}
          currentVotes={getReferralLinkVotes(link.id)}
          totalVotes={getReferralLinkTotalVotes(link.id)}
          showProgressBar={voteType === 'PER_ITEM' || voteType === 'ALL_ITEMS'}
          showVoteCount={voteType === 'PER_ITEM'}
          referralId={referralId}
          buttonColor={link.buttonColor}
          progressBarColor={link.barColor}
          progressBarCompleteColor={link.barCompleteColor}
          progressBarHighlightColor={link.barHighlightColor}
          onLinkClick={() => handleLinkClick(link)}
          layout={layout}
          mockVoting={mockVoting}
          cardClass={link.puckCardClass}
          cardStyle={link.puckCardStyle}
        />
      ))}
    </div>
  )
}

export default ReferralCardScreen
